import { createAsyncThunk } from "@reduxjs/toolkit";
import RepresentativeImageApiService, {
  AddRepresentativeImagePayload,
} from "../apiServices/RepresentativeImageApiService";

/**
 * Registers a new entry in the shared representative-image catalog (Admin >
 * Representative Images). Resolves to the server's copy of the record
 * (imageId/createdAt included) so the slice can prepend the canonical row.
 */
export const addRepresentativeImage = createAsyncThunk(
  "representativeImages/addRepresentativeImage",
  async (payload: AddRepresentativeImagePayload, { rejectWithValue }) => {
    try {
      return await RepresentativeImageApiService.add(payload);
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

const RepresentativeImageThunk = {
  addRepresentativeImage,
};

export default RepresentativeImageThunk;
